<template>
    <div class="order">
        <div>
            <table>
                <thead>
                    <tr class="th">
                        <td>订单号</td>
                        <td>品牌</td>
                        <td>货号</td>
                        <td>CAS</td>
                        <td>产品名称</td>
                        <td>数量</td>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in productList" :key="index" class="tr">
                        <td>{{ item.orderNo }}</td>
                        <td>{{ item.brandName }}</td>
                        <td>{{ item.itemNo }}</td>
                        <td>{{ item.cas }}</td>
                        <td>{{ item.chName }}</td>
                        <td>{{ item.goodsNum }}</td>
                    </tr>
                </tbody>
            </table>
            <div class="table-empty" v-if="!productList || productList.length === 0">
                <i class="el-icon-document-copy"></i>
                <p>暂无数据</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['product'],
    data() {
        return {
            query: {},
            formInline: {},
            productList: [],
            invoiceDialog: false,
        };
    },
    methods: {
        getOrder() {
            console.log(this.product);
            this.productList = this.product;
        },
        handleCurrentChange(page) {
            this.getOrder(page);
        },
    },
    mounted() {
        this.getOrder();
    },
    watch: {
        product: {
            handler(newValue) {
                this.productList = newValue;
            },
            deep: true,
        },
    },
};
</script>

<style lang="less" scoped>
.handle-select {
    width: 150px;
    display: inline-block !important;
}

.handle-input {
    width: 140px;
    display: inline-block;
}
.mr10 {
    margin-right: 10px;
    margin-bottom: 10px;
}
</style>
